var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12","offset-md":"2","md":"8","offset-lg":"3","lg":"6"}},[_c('b-card',[_c('organization-payment')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }